const state = () => ({
  availableSettings: {},
  activeSettings: {},
  disabledSettings: {},
  isPhoneConfirmed: false,
  confirmedNumber: null,
  telegramData: {
    assigned: false,
    bot_id: null,
    deassign_telegram_link: '',
    assign_telegram_link: ''
  }
})

const mutations = {
  set(state, { type, payload }) {
    state[type] = payload
  },

  setActiveSetting(state, { category, point, payload }) {
    state.activeSettings[category][point] = payload
  },

  setTelegramAssigned(state, value) {
    state.telegramData.assigned = value
  }
}

export default {
  state,
  mutations
}
